import type { PrimaryNavigationMode } from "./layoutRegistry";

export type ResolvedPrimaryNavigationMode =
  | PrimaryNavigationMode
  | "legacy";

export interface LegacyPrimaryNavigationContext {
  isGlobalPath: boolean;
  isConnectorDetailPath: boolean;
  isKnowledgeGraphPath: boolean;
}

/**
 * Converts optional route chrome into one explicit navigation presentation.
 * Routes without registry configuration retain their existing path-driven mode.
 * On a phone every route except `hidden` ones resolves to the drawer.
 */
export const resolvePrimaryNavigationMode = (
  configuredMode: PrimaryNavigationMode | undefined,
  legacyContext: LegacyPrimaryNavigationContext,
  isPhone = false,
): ResolvedPrimaryNavigationMode => {
  // Phones never get a rail or a docked sidebar: every route that shows navigation uses the drawer.
  if (isPhone) return configuredMode === "hidden" ? "hidden" : "drawer";
  if (configuredMode) return configuredMode;
  if (legacyContext.isGlobalPath) return "drawer";
  if (
    legacyContext.isConnectorDetailPath ||
    legacyContext.isKnowledgeGraphPath
  ) {
    return "compact";
  }
  return "legacy";
};
